module.exports = __webpack_public_path__ + "static/img/fg2.5b0428c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/fg2.png
// module id = GWzg
// module chunks = 0